const TextareaNew = ({ name, type = 'text', placeholder, value, onChange }) => {
  return (
    <textarea
      type={type}
      name={name}
      id={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="appearance-none border bg-white rounded-[10px] w-full h-[128px] text-[16px] py-[8px] px-[24px] resize-none text-gray-700 focus:placeholder-transparent focus:outline-none focus:shadow-outline "
    />
  );
};

export default TextareaNew;
